import { instanceToPlain } from "class-transformer";
import ProjectTeamRoleContributorsRequestResource from "common/resources/Project/Config/Team/Role/ProjectTeamRoleContributorsRequestResource";
import ProjectTeamRoleContributorsResponseResource from "common/resources/Project/Config/Team/Role/ProjectTeamRoleContributorsResponseResource";
import BaseProjectTeamIdApi from "./BaseProjectTeamIdApi";

export default class RoleApi extends BaseProjectTeamIdApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/roles`;
	}

	/**
	 * @description Get all by project team id
	 */
	public async getAllByProjectTeamId(projectId: string, projectTeamId: string): Promise<ProjectTeamRoleContributorsResponseResource[]> {
		return this.getRequest<ProjectTeamRoleContributorsResponseResource[]>(this.getBaseUrl({ projectId, projectTeamId })).then((response) =>
			ProjectTeamRoleContributorsResponseResource.hydrateArray(response),
		);
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, projectTeamId: string, roleId: string): Promise<ProjectTeamRoleContributorsResponseResource> {
		return this.getRequest<ProjectTeamRoleContributorsResponseResource>(`${this.getBaseUrl({ projectId, projectTeamId })}/${roleId}`).then((response) =>
			ProjectTeamRoleContributorsResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Create a new role with contributors for a project team
	 */
	public async create(projectId: string, projectTeamId: string, request: ProjectTeamRoleContributorsRequestResource): Promise<ProjectTeamRoleContributorsResponseResource> {
		return this.postRequest<ProjectTeamRoleContributorsResponseResource>(this.getBaseUrl({ projectId, projectTeamId }), instanceToPlain(request)).then((response) =>
			ProjectTeamRoleContributorsResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Update a role with contributors for a project team
	 */
	public async update(
		projectId: string,
		projectTeamId: string,
		roleId: string,
		request: ProjectTeamRoleContributorsRequestResource,
	): Promise<ProjectTeamRoleContributorsResponseResource> {
		return this.putRequest<ProjectTeamRoleContributorsResponseResource>(`${this.getBaseUrl({ projectId, projectTeamId })}/${roleId}`, instanceToPlain(request)).then(
			(response) => ProjectTeamRoleContributorsResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Add a contributor to a role for a project team
	 */
	public async addContributor(projectId: string, projectTeamId: string, roleId: string, contributorId: string): Promise<void> {
		return this.patchRequest(`${this.getBaseUrl({ projectId, projectTeamId })}/${roleId}/contributors/${contributorId}`);
	}

	/**
	 * @description Remove a contributor from a role for a project team
	 */
	public async removeContributor(projectId: string, projectTeamId: string, roleId: string, contributorId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId, projectTeamId })}/${roleId}/contributors/${contributorId}`);
	}

	/**
	 * @description Delete a role for a project team
	 */
	public async delete(projectId: string, projectTeamId: string, roleId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId, projectTeamId })}/${roleId}`);
	}
}
